import { useState, useCallback } from 'react';
import { useThrottledCallback } from 'use-debounce';

var useOnscrollShadow = function useOnscrollShadow(_ref) {
  var scrollableRef = _ref.scrollableRef,
      _ref$debounceTimeout = _ref.debounceTimeout,
      debounceTimeout = _ref$debounceTimeout === void 0 ? 100 : _ref$debounceTimeout;

  var _useState = useState('none'),
      shadow = _useState[0],
      setShadow = _useState[1];

  var getShadow = useCallback(function () {
    var el = scrollableRef.current;

    if (!el) {
      return 'none';
    }

    var clientHeight = el.clientHeight;
    var scrollTop = el.scrollTop;
    var scrollHeight = el.scrollHeight; // hack for FF because it calculates scrollHeight wrong when Noto Sans and overflow: auto
    // TODO research this or create issue to FF community

    if (scrollHeight === clientHeight || Math.abs(scrollHeight - clientHeight) === 1) {
      return 'none';
    }

    if (scrollTop === 0) {
      return 'bottom';
    }

    if (scrollTop + clientHeight === scrollHeight) {
      return 'top';
    }

    return 'both';
  }, [scrollableRef]);
  var handleScroll = useThrottledCallback(function () {
    setShadow(getShadow());
  }, debounceTimeout);
  return {
    handleScroll: handleScroll,
    shadow: shadow
  };
};

export { useOnscrollShadow };
